<template>
    <!--<l-layout>
        <wrapper>
            <div class="middle">-->
    <div class="pageView">
        <slot></slot>
    </div>
    <!--</div>
            <l-sidebar></l-sidebar>
        </wrapper>
    </l-layout>-->
</template>
<style type="text/css">

</style>
<script type="text/javascript">
    export default {
        data() {
            return {}
        },
        mounted() {},
        methods: {},
    }

</script>



// WEBPACK FOOTER //
// back-main.vue?f6edae7c